import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
            }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const CoralFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What is the Coral PMS strategy?",
      answer: "CORAL is our data-driven approach to sector investing through ETFs. It uses a structured, signal-based methodology to identify promising sectors in the Indian economy, removing guesswork while maximizing risk-adjusted returns compared to traditional index investing."
    },
    {
      question: "How does Coral select sectors?",
      answer: "We focus on 12 core sectors of the Indian economy and apply a rules-based system powered by historical performance trends. Our selection process analyzes key financial metrics including profit growth, efficiency ratios, margin expansion, and valuation indicators to identify sectors poised for outperformance."
    },
    {
      question: "What are the investment details?",
      answer: "The minimum investment is Rs. 50 lakhs, and the recommended time horizon is 3-5 years. Our ETF basket is updated quarterly based on sector analysis, offering a balance between diversification and focused exposure to high-potential sectors."
    },
    {
      question: "Why choose ETFs over individual stocks?",
      answer: "ETFs provide targeted exposure to high-performing sectors while reducing the risk of individual stock volatility. They offer a balanced approach between too much diversification (as in broad market indices) and over-concentration in individual companies, making them ideal for sector-based strategies."
    },
    {
      question: "How often is the portfolio rebalanced?",
      answer: "We update the ETF basket quarterly based on fresh sector data. This practical frequency allows for timely responses to economic shifts while avoiding excessive trading that could impact returns."
    },
    {
      question: "Who should invest in Coral?",
      answer: "CORAL is ideal for investors seeking targeted sector exposure beyond conventional index investments, those who value data-driven investment approaches, and investors looking for a scientifically structured approach to sector rotation with potentially higher risk-adjusted returns."
    }
  ];


  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Common Questions About CORAL PMS
            </h2>
            <p className="text-gray-600 mb-8">
              Get answers to frequently asked questions about our CORAL PMS offerings.
              For more detailed discussions, our investment experts are ready to help.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoralFAQ;